import Vue from 'vue'
import store from '../store'
import axios from './axios'
import ElementUI from 'element-ui'
import { ElementTiptapPlugin } from 'element-tiptap'
import { i18n } from './i18n'

Vue.use(ElementUI)
Vue.use(ElementTiptapPlugin, {
	lang: i18n.vm.locale,
	spellcheck: false
})

Vue.prototype.$axios = axios
Vue.prototype.$alertConfirm = (obj) => store.dispatch('alert/confirm', obj)
Vue.prototype.$alertBox = (obj) => store.dispatch('alert/box', obj)

Vue.prototype.$getImgUrl = (pic) => process.env.VUE_APP_BASE_API_IMG + pic
Vue.prototype.$getLocalImg = (pic) => require('@/assets/img/' + pic)

Vue.prototype.$compareValues = (key, order = 'asc') => {
	return function innerSort(a, b) {
		if (
			!Object.prototype.hasOwnProperty.call(a, key) ||
			!Object.prototype.hasOwnProperty.call(b, key)
		) {
			// property doesn't exist on either object
			return 0
		}

		const varA = typeof a[key] === 'string' ? a[key].toUpperCase() : a[key]
		const varB = typeof b[key] === 'string' ? b[key].toUpperCase() : b[key]

		let comparison = 0
		if (varA > varB) {
			comparison = 1
		} else if (varA < varB) {
			comparison = -1
		}
		return order === 'desc' ? comparison * -1 : comparison
	}
}
